module.exports = __webpack_public_path__ + "static/img/6.d6dea29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/zh/6.png
// module id = KDJi
// module chunks = 0